import { clsx } from 'clsx';
import { PLAYBOOK_GROUP_LABELS } from '../playbookLabels';

const TONE: Record<string, string> = {
  A_quente: 'bg-danger/10 text-danger',
  B_gerou_e_parou: 'bg-warning/10 text-warning',
  C_travou: 'bg-info/10 text-info',
  D_nunca_comecou: 'bg-subtle text-ink-secondary',
  E_fora_do_alvo: 'bg-subtle text-ink-tertiary',
};

/** Letra do grupo de abordagem; o nome completo fica no title. */
export function PlaybookBadge({ group }: { group: string | null | undefined }) {
  if (!group || !PLAYBOOK_GROUP_LABELS[group]) {
    return null;
  }
  return (
    <span
      title={PLAYBOOK_GROUP_LABELS[group]}
      className={clsx(
        'inline-flex h-5 min-w-5 items-center justify-center rounded px-1 text-[11px] font-semibold',
        TONE[group]
      )}
    >
      {group.charAt(0)}
    </span>
  );
}
